function isRowingBlazers() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('rowingblazers') !== -1;
}

export default isRowingBlazers;
